<script>
import pagination from '../../../mixins/pagination';
import {mapGetters} from 'vuex';

export default {
  mixins: [pagination],
  props: {
    size: {
      type: Number,
      required: false,
      default: ACC.allocatedItemsPageSize || 50,
    },
    warehouse: {
      type: Object,
      default: () => {},
    },
    shipmentInfo: {
      type: Object,
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    sectionKey: {
      type: String,
      default: '',
    },
  },

  inject: [],

  data() {
    return {
      listData: this.items,
      pageSize: this.size,
      addPrice: String,
    };
  },
  computed: {
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  methods: {
    getColumns() {
      // The "Backordered" shouldn't have the Allocated or Cancel Date columns
      return this.headers.filter(this.filterColumns);
    },
    filterColumns(column) {
      if (this.sectionKey === 'notAllocatedItems') {
        if (column.key === 'quantityAllocatedOrShipped' || column.key === 'cancelDate') return false;
      }
      if (this.sectionKey === 'allocatedItems') {
        if (column.key === 'etaDate') return false;
      }
      if (this.consumerFriendlyMode && (column.key === 'unitPrice' || column.key == 'lineSubtotal')) return false;
      return true;
    },
  },
};
</script>
